import { useQuery } from '@tanstack/react-query'

import { fetchCourtPriceBands } from '@/lib/venue/priceApi'
import type { CourtPriceBandView } from '@/lib/venue/priceTypes'

export function courtPriceBandsQueryKey(venueId: string, courtId: number) {
  return ['venue', venueId, 'courts', courtId, 'price-bands'] as const
}

export function useCourtPriceBands(venueId: string, courtId: number) {
  return useQuery<CourtPriceBandView>({
    queryKey: courtPriceBandsQueryKey(venueId, courtId),
    queryFn: () => fetchCourtPriceBands(venueId, courtId),
  })
}
